export const getElements = state => state.elements
export const getData = state => state.dataByElement
export const getIsFetching = state => state.dataIsFetching
